import React, { useEffect, useCallback } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LoadingIcon from "mdi-react/LoadingIcon";
import { marked } from "marked";

import { reelsConstants, string } from "../../constants";
import { reelsActions } from "../../redux/actions";

const DetailRow = ({ label, value }) =>
  value ? (
    <div className="row w-100">
      <div className="col-12 col-md-4 col-lg-3 col-xl-2 py-1 py-md-2 recap-detail-heading">
        {label}
      </div>
      <div className="col-12 col-md-8 col-lg-9 col-xl-10 py-1 py-md-2 recap-detail-info">
        {value}
      </div>
    </div>
  ) : null;

const ReelDetailModal = (props) => {
  const { t } = useTranslation();

  const details = props.reelDetail?.reelDetails?.[0] || {};

  const spinner = useCallback(
    (type) => props.spinnerActions.findIndex((f) => f === type),
    [props.spinnerActions]
  );

  useEffect(() => {
    if (props?.reelDetailModalReelId) {
      props.getReelDetails(props?.reelDetailModalReelId);
    }
    // eslint-disable-next-line
  }, [props?.reelDetailModalReelId]);

  // Handle view reels detail of an event
  useEffect(() => {
    if (props?.reelDetailModalEventId) {
      props.getReelsByEventId(props.reelDetailModalEventId);
    }
    // eslint-disable-next-line
  }, [props?.reelDetailModalEventId]);

  // Handle view reels detail of an group event
  useEffect(() => {
    if (props?.reelDetailModalEventGroupId) {
      props.getReelsByEventGroupId(props.reelDetailModalEventGroupId);
    }
    // eslint-disable-next-line
  }, [props?.reelDetailModalEventGroupId]);

  const reset = () => {
    props.setIsReelDetailModalOpen(false);
    props.setIsReelDetailModalEventId(null);
    props.setIsReelDetailModalReelId(null);
    props.setReelDetailModalEventGroupId(null);
  };

  const getFormattedHtml = (text = "") => {
    // Simple check if text contains HTML tags
    const isHtml = /<\/?[a-z][\s\S]*>/i.test(text);

    return {
      __html: isHtml ? text : marked.parse(text),
    };
  };

  const primaryReels = props.allReels.filter(
    (reel) => !reel.isCombinedEventsReel
  );
  const combinedReels = props.allReels.filter(
    (reel) => reel.isCombinedEventsReel
  );

  const primaryDescription =
    props.allReels.find((reel) => !reel.isCombinedEventsReel)?.description ||
    string.EMPTY;

  const combinedDescription =
    props.allReels.find((reel) => reel.isCombinedEventsReel)?.description ||
    string.EMPTY;

  return (
    <Modal
      isOpen={props.isReelDetailModalOpen}
      onRequestClose={() => reset()}
      className={"reel-detail-con"}
    >
      <span className="close" onClick={() => reset()}>
        x
      </span>
      {spinner(reelsConstants.GET_REEL_DETAILS) &&
      spinner(reelsConstants.GET_REELS_BY_EVENT_ID) &&
      spinner(reelsConstants.GET_REELS_BY_EVENT_GROUP_ID) ? (
        <>
          <div className="container-fluid main-con">
            <div className="row header">
              <div className="col-12">Recap Brief</div>
              <div className="col-12">
                {props?.reelDetailModalEventId
                  ? props?.reelDetailModalEventId
                  : props?.reelDetailModalEventGroupId
                    ? props?.reelDetailModalEventGroupId
                    : ""}
              </div>
            </div>
            <div className="w-100 my-3">
              {props?.reelDetailModalReelId ? (
                <>
                  <DetailRow
                    label="Logo Url:"
                    value={
                      details.logoUrl && (
                        <a
                          href={`${process.env.REACT_APP_S3_BASE_URL_EVENTS_GALLERY}/${details.logoUrl}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "underline" }}
                        >
                          {`${process.env.REACT_APP_S3_BASE_URL_EVENTS_GALLERY}/${details.logoUrl}`}
                        </a>
                      )
                    }
                  />
                  <DetailRow label="Orientation:" value={details.orientation} />
                  <DetailRow label="Recap Type:" value={details.reelMode} />
                  <div className="row w-100">
                    <div className="col-12 col-md-4 col-lg-3 col-xl-2 py-1 py-md-2 recap-detail-heading">
                      Editing Brief:
                    </div>
                    <div
                      className="col-12 col-md-8 col-lg-9 col-xl-10 py-1 py-md-2 formatted-html"
                      dangerouslySetInnerHTML={getFormattedHtml(
                        details.description
                      )}
                    />
                  </div>
                  <br />
                </>
              ) : (
                props.allReels?.length > 0 && (
                  <>
                    {props.allReels.map((reel) => (
                      <>
                        <DetailRow label="Name:" value={reel.reelName} />
                        <DetailRow
                          label="Orientation:"
                          value={reel.orientation}
                        />
                        <DetailRow label="Recap Type:" value={reel.reelType} />
                        <div className="row w-100">
                          <div className="col-12">
                            <hr />
                          </div>
                        </div>
                      </>
                    ))}
                    {primaryDescription && (
                      <>
                        <div className="row w-100">
                          <div className="col-12 col-md-4 col-lg-3 col-xl-2 py-1 py-md-2 recap-detail-heading">
                            Editing Brief:
                          </div>
                          <div
                            className="col-12 col-md-8 col-lg-9 col-xl-10 py-1 py-md-2 formatted-html"
                            dangerouslySetInnerHTML={getFormattedHtml(
                              primaryDescription
                            )}
                          />
                        </div>
                        {combinedDescription && (
                          <div className="row w-100">
                            <div className="col-12">
                              <hr />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {combinedDescription && (
                      <>
                        <div className="row w-100">
                          <div className="col-12 col-md-4 col-lg-3 col-xl-2 py-1 py-md-2 recap-detail-heading">
                            Combined Editing Brief:
                          </div>
                          <div
                            className="col-12 col-md-8 col-lg-9 col-xl-10 py-1 py-md-2 formatted-html"
                            dangerouslySetInnerHTML={getFormattedHtml(
                              combinedDescription
                            )}
                          />
                        </div>
                      </>
                    )}
                  </>
                )
              )}
            </div>
          </div>
        </>
      ) : (
        <div className="text-center mt-4">
          <LoadingIcon className="loading-spinner" />
        </div>
      )}
    </Modal>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  spinnerActions: state.system.spinnerActions,
  allReels: state.reels.allReels,
  reelDetail: state.reels.reelDetail,
  isReelDetailModalOpen: state.reels.isReelDetailModalOpen,
  reelDetailModalEventId: state.reels.reelDetailModalEventId,
  reelDetailModalEventGroupId: state.reels.reelDetailModalEventGroupId,
  reelDetailModalReelId: state.reels.reelDetailModalReelId,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getReelDetails: (eventId, reelId) =>
    dispatch(reelsActions.getReelDetails(eventId, reelId)),
  getReelsByEventId: (eventId) =>
    dispatch(reelsActions.getReelsByEventId(eventId)),
  getReelsByEventGroupId: (eventGroupId) =>
    dispatch(reelsActions.getReelsByEventGroupId(eventGroupId)),
  setIsReelDetailModalOpen: () =>
    dispatch({ type: reelsConstants.SET_IS_REEL_DETAIL_MODAL_OPEN }),
  setIsReelDetailModalEventId: () =>
    dispatch({ type: reelsConstants.SET_REEL_DETAIL_MODAL_EVENT_ID }),
  setReelDetailModalEventGroupId: () =>
    dispatch({ type: reelsConstants.SET_REEL_DETAIL_MODAL_EVENT_GROUP_ID }),
  setIsReelDetailModalReelId: () =>
    dispatch({ type: reelsConstants.SET_REEL_DETAIL_MODAL_REEL_ID }),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReelDetailModal));
